// extracted by mini-css-extract-plugin
module.exports = {"serviceContact":"service-contact-module--serviceContact--2ThqC"};